import React, { useState } from "react";
import "../../../css/TableCard.css"; // Add styles here or use inline styles
import useRequestDetailedData from "../../../utils/useRequestDetailedData";

const TableCard = ({ item }) => {
    const {
        request,
        requestParameters,
        requestResponseParameters,
        requestResponseData,
        loading,
        error,
    } = useRequestDetailedData(item.requestId, item, true);

    const [selectedRange, setSelectedRange] = useState("today");

    const timeRanges = [
        { label: "Today", value: "today" },
        { label: "Yesterday", value: "yesterday" },
        { label: "This Week", value: "this_week" },
        { label: "Last Week", value: "last_week" },
        { label: "This Month", value: "this_month" },
        { label: "Last Month", value: "last_month" },
        { label: "This Year", value: "this_year" },
        { label: "Last Year", value: "last_year" },
    ];

    const handleTimeRangeChange = (e) => {
        setSelectedRange(e.target.value);
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div className="error">Error: {error}</div>;
    }

    // Ensure requestResponseParameters is an array
    const responseParameters = Array.isArray(requestResponseParameters)
        ? requestResponseParameters
        : [];

    return (
        <div className="table-card w-100 m-0 h-100">
            <div className="table-header">
                <h4 className="table-title">{item.name}</h4>
                {/* Show the time range dropdown only when range is true */}
                {item.range && (
                    <select
                        className="time-range-dropdown"
                        value={selectedRange}
                        onChange={handleTimeRangeChange}
                    >
                        {timeRanges.map((range) => (
                            <option key={range.value} value={range.value}>
                                {range.label}
                            </option>
                        ))}
                    </select>
                )}
            </div>
            <table className="table">
                <thead>
                    <tr>
                        {responseParameters.map((param, index) => (
                            <th key={index}>{param.label || param.name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(requestResponseData) && requestResponseData.length > 0 ? (
                        requestResponseData.map((dataRow, rowIndex) => (
                            <tr key={rowIndex}>
                                {responseParameters.map((param, colIndex) => (
                                    <td key={colIndex}>{dataRow[param.name]}</td>
                                ))}
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={responseParameters.length + 1}>
                                No data available.
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TableCard;
